<template>
    <div class="agreement-wrapper">
        <Information name="rightProtection"/>
    </div>
</template>

<script>

import Information from '@/components/Information.vue'

export default {
    name: 'RightProtection',
    components: {
        Information
    }
}
</script>
